
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComMicMutedGoogle as ObiComMicMutedGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-mic-muted-google.js';
 
 
 

 
 export const ObiComMicMutedGoogle = createComponent({
   react: React,
   tagName: 'obi-com-mic-muted-google',
   elementClass: ObiComMicMutedGoogleElement,
   events: {
     
   }
  });
 
 